(function () {
  function parseSlides(value, fallback) {
    var parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function parseDelay(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) && parsed >= 1000 ? parsed : fallback;
  }

  function initCampMediaSliders() {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('[data-rng-camp-media-slider]').forEach(function (slider) {
      if (slider.dataset.initialized === 'true') return;

      var slideCount =
        parseInt(slider.dataset.slideCount, 10) ||
        slider.querySelectorAll('.swiper-slide').length;

      if (slideCount <= 1) return;

      var card = slider.closest('article');
      var paginationEl = card
        ? card.querySelector('[data-rng-camp-media-pagination]')
        : null;
      var autoplayDelay = parseDelay(slider.dataset.autoplayDelay, 4000);

      new Swiper(slider, {
        nested: true,
        loop: true,
        speed: 600,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        autoplay: {
          delay: autoplayDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        pagination: paginationEl
          ? {
              el: paginationEl,
              clickable: true
            }
          : undefined
      });

      slider.dataset.initialized = 'true';
    });
  }

  function setActiveCampFilter(section, filterButton) {
    section.querySelectorAll('[data-rng-camps-filter]').forEach(function (button) {
      var isActive = button === filterButton;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function applyCampFilter(section) {
    var activeFilter = section.dataset.activeFilter || '';
    var showAll = !activeFilter || activeFilter === 'all-camps';

    section
      .querySelectorAll('[data-rng-camps-grid-items] .rng-camps-grid-item')
      .forEach(function (item) {
        var tags = (item.dataset.campTags || '')
          .split(/\s+/)
          .filter(Boolean);

        var isVisible = showAll || tags.indexOf(activeFilter) !== -1;

        item.classList.toggle('hidden', !isVisible);
        item.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      });
  }

  function bindCampFilters(section) {
    if (section.dataset.filtersBound === 'true') {
      applyCampFilter(section);
      return;
    }

    var filterButtons = Array.prototype.slice.call(
      section.querySelectorAll('[data-rng-camps-filter]')
    );

    if (!filterButtons.length) {
      section.dataset.activeFilter = '';
      applyCampFilter(section);
      return;
    }

    filterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setActiveCampFilter(section, button);
        section.dataset.activeFilter =
          button.dataset.rngCampsFilter || '';
        applyCampFilter(section);
      });
    });

    /*
      Open the grid showing every camp by default.

      If an "All Camps" filter exists, activate it.
      If it does not exist, no category filter is activated initially,
      so the grid still shows all selected camps.
    */
    var allCampsButton = filterButtons.find(function (button) {
      return button.dataset.rngCampsFilter === 'all-camps';
    });

    if (allCampsButton) {
      setActiveCampFilter(section, allCampsButton);
      section.dataset.activeFilter = 'all-camps';
    } else {
      setActiveCampFilter(section, null);
      section.dataset.activeFilter = '';
    }

    section.dataset.filtersBound = 'true';
    applyCampFilter(section);
  }

  function initCampInclusionsDropdowns() {
    document
      .querySelectorAll('[data-rng-camp-inclusions-dropdown]')
      .forEach(function (details) {
        if (details.dataset.inclusionsBound === 'true') return;

        details.addEventListener('toggle', function () {
          if (!details.open) return;

          document
            .querySelectorAll('[data-rng-camp-inclusions-dropdown][open]')
            .forEach(function (other) {
              if (other !== details) other.open = false;
            });
        });

        details.dataset.inclusionsBound = 'true';
      });

    if (
      document.documentElement.dataset.rngCampInclusionsOutsideBound ===
      'true'
    ) {
      return;
    }

    document.addEventListener('click', function (event) {
      document
        .querySelectorAll('[data-rng-camp-inclusions-dropdown][open]')
        .forEach(function (details) {
          if (!details.contains(event.target)) {
            details.open = false;
          }
        });
    });

    document.documentElement.dataset.rngCampInclusionsOutsideBound = 'true';
  }

  function initCampsGrid(section) {
    bindCampFilters(section);
    initCampMediaSliders();
  }

  function initCampsSliders() {
    if (typeof Swiper === 'undefined') return;

    initCampMediaSliders();

    document
      .querySelectorAll('[data-rng-camps-slider]')
      .forEach(function (slider) {
        if (slider.dataset.initialized === 'true') return;

        var section = slider.closest('.rng-camps');
        var prevEl = section
          ? section.querySelector('.rng-camps-prev')
          : null;
        var nextEl = section
          ? section.querySelector('.rng-camps-next')
          : null;

        new Swiper(slider, {
          slidesPerView: parseSlides(
            slider.dataset.slidesMobile,
            1.1
          ),
          spaceBetween: 20,
          watchOverflow: true,
          grabCursor: true,
          navigation: {
            prevEl: prevEl,
            nextEl: nextEl
          },
          breakpoints: {
            640: {
              slidesPerView: parseSlides(
                slider.dataset.slidesTablet,
                2
              ),
              spaceBetween: 22
            },
            1024: {
              slidesPerView: parseSlides(
                slider.dataset.slidesDesktop,
                3
              ),
              spaceBetween: 25
            }
          }
        });

        slider.dataset.initialized = 'true';
      });
  }

  function boot() {
    initCampInclusionsDropdowns();

    document
      .querySelectorAll('[data-rng-camps-grid]')
      .forEach(function (section) {
        initCampsGrid(section);
      });

    if (typeof Swiper !== 'undefined') {
      initCampsSliders();
      return;
    }

    var attempts = 0;
    var interval = window.setInterval(function () {
      attempts += 1;

      if (typeof Swiper !== 'undefined') {
        window.clearInterval(interval);
        initCampsSliders();
      } else if (attempts > 50) {
        window.clearInterval(interval);
      }
    }, 100);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();